import { createActions, createReducer } from 'reduxsauce';

// ✅ ACTION TYPES + CREATORS
const { Types, Creators } = createActions(
  {
    // Coupons
    getCoupons: ['params'],
    getCouponsRequest: [],
    getCouponsSuccess: ['coupons'],
    getCouponsFailure: ['error'],

    // Products by MIDs
    getProductsByMids: ['mids'],
    getProductsByMidsRequest: [],
    getProductsByMidsSuccess: ['products'],
    getProductsByMidsFailure: ['error'],

    // Businesses (formerly Approved MIDs)
    getBusinesses: [],
    getBusinessesRequest: [],
    getBusinessesSuccess: ['businesses'],
    getBusinessesFailure: ['error'],
  },
  { prefix: 'cb/rakuten/' }
);

// ✅ INITIAL STATE
export const INITIAL_STATE = {
  coupons: [],
  products: [],
  businesses: [],     // formerly mids
  loading: {
    coupons: false,
    products: false,
    businesses: false,
  },
  error: {
    coupons: null,
    products: null,
    businesses: null,
  },
};

// ✅ REDUCER HANDLERS
export const HANDLERS = {
  // COUPONS
  [Types.GET_COUPONS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, coupons: true },
    error: { ...state.error, coupons: null },
  }),
  [Types.GET_COUPONS_SUCCESS]: (state, { coupons }) => ({
    ...state,
    loading: { ...state.loading, coupons: false },
    coupons,
  }),
  [Types.GET_COUPONS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, coupons: false },
    error: { ...state.error, coupons: error },
  }),

  // PRODUCTS BY MIDS
  [Types.GET_PRODUCTS_BY_MIDS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, products: true },
    error: { ...state.error, products: null },
  }),
  [Types.GET_PRODUCTS_BY_MIDS_SUCCESS]: (state, { products }) => ({
    ...state,
    loading: { ...state.loading, products: false },
    products,
  }),
  [Types.GET_PRODUCTS_BY_MIDS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, products: false },
    error: { ...state.error, products: error },
  }),

  // BUSINESSES
  [Types.GET_BUSINESSES_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, businesses: true },
    error: { ...state.error, businesses: null },
  }),
  [Types.GET_BUSINESSES_SUCCESS]: (state, { businesses }) => ({
    ...state,
    loading: { ...state.loading, businesses: false },
    businesses,
  }),
  [Types.GET_BUSINESSES_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, businesses: false },
    error: { ...state.error, businesses: error },
  }),
};

// ✅ EXPORT
export { Types as types, Creators as actions };
export default createReducer(INITIAL_STATE, HANDLERS);
